<template>
  <div>
    <div class="grid_flex justify-space-between">
      <div class="detail_flex">
        <div class="mr-2">ผู้สร้างโปรโมชั่น :</div>
        <div class="mr-2">{{ $props.user }} <span>{{ $props.create_time }}</span></div>
      </div>
      <div class="d-flex">
        <div class="mr-2">สถานะ</div>
        <div v-if="$props.status === 0" style="color: red">ปิดการขาย</div>
        <div v-if="$props.status === 1" style="color: #86bc3a">จำหน่าย</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "usercreate_promotion",
  props: ['status', 'user', 'create_time']
}
</script>

<style scoped>
.grid_flex {
  display: flex;
}
.detail_flex {
  display: flex;
}
@media only screen and (max-width: 600px) {
  .grid_flex {
    display: grid;
    grid-template-columns: 100%;
    grid-gap: 15px 0;
  }
  .detail_flex {
    display: grid;
    grid-template-columns: 100%;
  }
}
</style>
